module.exports = __webpack_public_path__ + "static/img/11b660cf7f3e08326e3d32561df988f4 (1).6910080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/11b660cf7f3e08326e3d32561df988f4 (1).png
// module id = k5LL
// module chunks = 1